import CityPage from "../CityPage";

export default function CrestHill() {
  return <CityPage slug="crest-hill" />;
}
